// src/environments/environment.prod.ts
export const environment = {
  production: true,
  apiUrl: 'https://dotnetbackend-cndev-cffce5cdandwgrhw.eastus-01.azurewebsites.net/api',
  redirectUri: 'https://uat.rosnyc.com',
  clientId: '5fb11494-a2b1-463e-9694-273a032c4571',
  authority: 'https://login.microsoftonline.com/cab76482-a96f-4cfa-929c-95fa700cde60'
};
